var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRank4CrownFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.433 8.8c0-.982-.772-1.776-1.72-1.776-.946 0-1.722.794-1.722 1.776s.772 1.776 1.72 1.776c.946 0 1.718-.798 1.718-1.776h.004zM31.008 8.8c0-.982-.771-1.776-1.718-1.776-.948 0-1.723.794-1.723 1.776s.772 1.776 1.719 1.776c.947 0 1.719-.798 1.719-1.776h.003zM17.72 3.74c0-.983-.771-1.777-1.718-1.777s-1.723.794-1.723 1.776.772 1.776 1.719 1.776c.947 0 1.719-.798 1.719-1.776h.004zM16.704 22.044h-2.8l2.8-4.288v4.288z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.256 7.024c.896 3.051 3.475 6.211 6.518 6.212 2.006 0 3.833-.79 5.086-2.07.142.081.321.136.5.163 0 0-3.387 11.203-3.387 18.657h-9.036V30h-.085v-.014H6.818c0-7.454-3.387-18.657-3.387-18.657.179-.027.358-.082.5-.164 1.256 1.28 3.08 2.071 5.088 2.071 3.046 0 5.623-3.16 6.52-6.212.107.027.213.027.321.027h.074c.108 0 .214 0 .322-.027zm2.608 8.075h-2.432l-4.736 7.216v1.537h5.008v2.288h2.16v-2.288h1.44v-1.808h-1.44V15.1z",
    fill: "#767676"
  })));
}

export default SvgIconRank4CrownFilled;